import { DataTable, EmptyState, type Spalte } from '../../muster';

/** Die Toleranzen und Zuschläge — Rastermaß, Montagezuschlag, Toleranz. */
export function Toleranzen({ einstellungen }: { einstellungen: any[] }) {
  const spalten: Spalte<any>[] = [
    {
      schluessel: 'groesse', titel: 'Größe', immerSichtbar: true,
      wert: (e) => e.schluessel.replace(/_/g, ' '),
    },
    {
      // Die Einheit steht je Zeile eine andere (mm, %, m) — deshalb hier
      // neben dem Wert und nicht an der Spaltenüberschrift.
      schluessel: 'wert', titel: 'Wert', ausrichtung: 'rechts', breite: '130px',
      wert: (e) => e.wert,
      inhalt: (e) => <>{e.wert} {e.einheit}</>,
    },
    {
      schluessel: 'herkunft', titel: 'Herkunft', breite: '160px',
      wert: (e) => e.herkunft,
      inhalt: (e) => <span className="schwach" style={{ fontSize: 11 }}>{e.herkunft}</span>,
    },
    {
      schluessel: 'begruendung', titel: 'Begründung',
      wert: (e) => e.begruendung,
      inhalt: (e) => <span style={{ fontSize: 12 }}>{e.begruendung}</span>,
    },
  ];

  return (
    <DataTable
      name="Toleranzen und Zuschläge"
      spalten={spalten}
      zeilen={einstellungen ?? []}
      schluessel={(e) => e.schluessel}
      suche={(einstellungen ?? []).length > 8}
      ausfuhr
      leer={(
        <EmptyState
          titel="Keine Toleranz hinterlegt."
          erklaerung={'Rastermaß, Montagezuschlag und Toleranz stehen in der Datenbank '
            + 'und entstehen mit den Koordinationsgrundlagen.'}
        />
      )}
    />
  );
}
